import type { ApplicationTabId } from '../api/application-query.constants';

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface RenewalBackState {
  dealId: string | null;
  source: string | null;
  /** Tracker tab the renewal form was opened from; the form exits back to it. */
  tab: ApplicationTabId | null;
  setOrigin: (dealId: string, source: string, tab?: ApplicationTabId | null) => void;
  clearOrigin: () => void;
}

export const useRenewalBackStore = create<RenewalBackState>()(
  devtools(
    (set) => ({
      dealId: null,
      source: null,
      tab: null,
      setOrigin: (dealId, source, tab = null) => set({ dealId, source, tab }),
      clearOrigin: () => set({ dealId: null, source: null, tab: null }),
    }),
    { name: 'renewal-back-store' },
  ),
);
